import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  errorText: PropTypes.string,
};

export default class LineLoader extends React.Component {
  render() {
    const classes = this.props.errorText ? 'line-error rec-notification-error' : 'line-loader';
    return <div className={classes}>{this.props.errorText}</div>;
  }
}

LineLoader.propTypes = propTypes;
